import script from "./PantallaEmpleado.vue?vue&type=script&setup=true&lang=js"
export * from "./PantallaEmpleado.vue?vue&type=script&setup=true&lang=js"

import "./PantallaEmpleado.vue?vue&type=style&index=0&id=184b661e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-184b661e"]])

export default __exports__